// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import 'lib-flexible/flexible'// px转rem插件
import './assets/js/rem' // px转rem

import echarts from "echarts";

Vue.prototype.$echarts = echarts;


// 共通ajax
import {
  get,
  post
} from './utils/api'

Vue.prototype.$post = post
Vue.prototype.$get = get

import {
  Button,
  Select,
  Row,
  Col,
  Option,
  Table,
  TableColumn,
  Pagination,
  Tag,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  DatePicker,
  Image,
  Dialog,
  Radio,
  RadioGroup,
  RadioButton,
  Upload,
  Link,
  Switch,
  Loading,
  MessageBox,
  Message,
  Form,
  FormItem
  , Checkbox, checkboxGroup,Progress
} from 'element-ui';

Vue.component(checkboxGroup.name,checkboxGroup);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Option.name, Option);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Pagination.name, Pagination);
Vue.component(Tag.name, Tag);
Vue.component(Container.name, Container);
Vue.component(Header.name, Header);
Vue.component(Aside.name, Aside);
Vue.component(Main.name, Main);
Vue.component(Menu.name, Menu);
Vue.component(Submenu.name, Submenu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(MenuItemGroup.name, MenuItemGroup);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(BreadcrumbItem.name, BreadcrumbItem);
Vue.component(Input.name, Input);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Image.name, Image);
Vue.component(Dialog.name, Dialog);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Upload.name, Upload);
Vue.component(Link.name, Link);
Vue.component(Radio.name, Radio);
Vue.component(Switch.name, Switch);
Vue.component(Message.name, Message);
Vue.component(MessageBox.name, MessageBox);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Progress.name,Progress);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js